/* ==========================================================================
  main.js
========================================================================== */

/**
 * Primary menu
 */
var primary_menu = component_primary_menu({
  desktop_min_width: 1079,
  menu: '#mobile-navigation',
  //menu: '.primary-navigation__mobile',
  //upper_menu: '.upper-navigation__mobile',
  search_component: '.search-form__mobile',
  menu_toggle: '#menu-toggle'
});

/**
 * menu-hidden search button
 */
document.getElementById('site-header__search-button').addEventListener("click", function(){
  document.getElementById('menu-toggle').click();
  document.getElementById('search-form-input-2').focus();
});


/**
 * Responsive videos
 */
fitvids({
  ignore: ['.wp-block-media-text__media iframe']
});

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Lightbox (Tobi.js) support for native gallery and images
 * Requires link to media file from gallery settings.
 */
/* Try to find the a-tag parents to the images (except with the last two selectors), both gutenberg and classic editor
    Selectors:
      gutenberg gallery,
      classic gallery,
      gutenberg images AND classic images with caption,
      classic images without caption and with no or center align
      classic image without caption and with left or right align
*/
var imgItems = document.querySelectorAll('.blocks-gallery-item > figure > a, .gallery-item > .gallery-icon > a, .wp-block-image a, p > a > img, p > a > .wp-block-image');
// if found, add .lightbox class that Tobi uses as selector to the items
if (imgItems.length) {
  imgItems.forEach(function(item) {
    var formats = ['.jpg', '.png', '.jpeg'];
    // check (3 first selectors) href to verify media link
    if (item.href) {
      if (formats.some(el => item.href.includes(el))) {
        item.classList.add('lightbox');
      }
      // check for figcaption (images and gutenberg gallery) and add it to a data attribute
      if (item.nextElementSibling) {
        if (item.nextElementSibling.nodeName.toLowerCase() === 'figcaption') {
          item.dataset.caption = item.nextElementSibling.innerText;
        }
      } else if (item.parentNode.nextElementSibling) { // classic gallery
        if (item.parentNode.nextElementSibling.nodeName.toLowerCase() === 'figcaption') {
          item.dataset.caption = item.parentNode.nextElementSibling.innerText;
        }
      }
    } else if (item.parentNode.href) { // check (2 last selectors) href to verify media link
      if (formats.some(el => item.parentNode.href.includes(el))) {
        item.parentNode.classList.add('lightbox');
      }
    }
  });
}
if(document.querySelectorAll('.lightbox').length) {
  // init Tobi
  try {
    const tobi = new Tobi({
      // variables from script localization
      navLabel: [gc_strings.prev, gc_strings.next],
      closeLabel: gc_strings.close,
      loadingIndicatorLabel: gc_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
  });
  } catch (e) {
    console.log(e);
  }
}

/**
 * Track product retailer clicks
 */
var retailer_click_event_tracked = false;
var gc_track_retailer_links = function(e) {
  // track events
  if (retailer_click_event_tracked == false) {
    if (window.ga && ga.loaded) {
      ga('send', {
        hitType: 'event',
        eventCategory: 'Jalleenmyyjat',
        eventAction: 'klikattu',
        eventLabel: e.currentTarget.getAttribute('data-title')
      });
      retailer_click_event_tracked = true;
    }
  }
}
var retailer_links = document.querySelectorAll('.js-retailer-link');
for (var i = (retailer_links.length - 1); i >= 0; i--) {
  retailer_links[i].addEventListener('click', gc_track_retailer_links);
}
